<template lang="pug">
.container
  .searchBarContent.mb-5
    p.mb-0 從
    input(type="date" v-model="startDate").form-control.rounded-0
    p.mb-0 至
    input(type="date" v-model="endDate").form-control.rounded-0
  .searchbar
    form.form-inline
      input.form-control.mr-sm-2(type="search" placeholder="查詢" aria-label="Search" v-model="orderNumber")
      button.btn.btn-outline-primary.my-2.my-sm-0(@click="getOrder") 查詢

  .table-responsive
    table.table
      thead
        tr
          th(scope='col').border-top-0.px-0 訂單日期
          th(scope='col').border-top-0.px-0 訂單編號
      tbody
        tr(v-for="item in orderAry")
          th(scope='row') {{item.orderdate}}
          td.text-primary.font-weight-bold
            router-link(to="/upload/orderid") {{item.ordernumber}}

  </template>

<script>
import {mapActions, mapState} from 'vuex'
import { createHelpers } from 'vuex-map-fields'
import alert from '../components/alert'

const { mapFields } = createHelpers({
  getterType: 'orderSearchModules/getField',
  mutationType: 'orderSearchModules/updateField'
})
export default{
  components: {alert},
  computed: {
    ...mapFields(['startDate', 'endDate']),
    ...mapState('orderSearchModules', ['orderAry'])
  },
  methods: {
    ...mapActions('orderSearchModules', ['getOrder', 'init'])
  },
  created () {
    let vm = this
    vm.init()
  }
}
</script>

  <style lang="scss" scoped>
  .title{
    font-size: 24px;
    font-weight: bold;
    font-family: "Noto Serif TC",serif;
  }
  .searchBtn{
    flex-shrink: 0;
  }

  @media(min-width: 640px) {
    .searchBarContent{
      display:flex;
      justify-content:center;
      align-items:center;
      input[type="date"]{
        margin:0 8px;
      }
    }
  }
  @media(max-width: 641px) {
    .searchBarContent{
      display:flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      input[type="date"]{
        margin:0 0 8px;
      }
    }
  }

  th,td{
    vertical-align: middle;
    text-align: center;
  }
  </style>



// WEBPACK FOOTER //
// src/components/searchOrder.vue